var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1427.39 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 194.19,
    y1: 529.8,
    x2: 194.19,
    y2: -118.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "footer logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M929.07,145.44A179.39,179.39,0,0,0,622.75,272.32v234.8h47.73V272.32c0-72.62,59.09-131.7,131.71-131.7S933.9,199.7,933.9,272.32v234.8h47.73V272.32a178.93,178.93,0,0,0-52.56-126.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1426.39,300a206.88,206.88,0,0,0-407.65-49.83,207.79,207.79,0,0,0-6,49.83A206.89,206.89,0,0,0,1328.4,475.92a207.74,207.74,0,0,0,74.76-80.6l2.3-4.44-42.35-22-2.31,4.44a159.15,159.15,0,0,1-298.59-49.43h364.18Zm-364.21-23.87a159.15,159.15,0,0,1,157.36-135.24,159,159,0,0,1,157.33,135.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.82,89.18A298.14,298.14,0,1,0,87.18,510.82,298.14,298.14,0,1,0,508.82,89.18ZM438.46,508.39a252.91,252.91,0,1,1,37.22-30.71A251.82,251.82,0,0,1,438.46,508.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.28,332.2H414.36a14.42,14.42,0,0,0-10,4l-30.52,29.47h0l-31.18-46.1q3.1-.66,6.12-1.53a91.46,91.46,0,0,0-25.47-179.31h-195l12.13,17.28h0l26.3,37.44H323.31a36.72,36.72,0,1,1,0,73.44H221.55v0H166.83V480.76h54.72V321.66H278l55.89,82.65h0l-79.19,76.47h72.92a14.4,14.4,0,0,0,10-4L365,450.31,383,477a8.65,8.65,0,0,0,7.16,3.81h61.49l-46.7-69.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.63,321.66h9.92a0,0,0,0,1,0,0v159.1a0,0,0,0,1,0,0H166.83a0,0,0,0,1,0,0V366.46A44.8,44.8,0,0,1,211.63,321.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/footer logo.a73b4f41b2afb064a8523fbd9cdc6db0.svg";
export { ForwardRef as ReactComponent };